import React from "react";
import {
  ScreenFlow,
  RecruitmentSteps,
} from "../../components";

const flowarray = [
  { title: "Home", link: "/" },
  { title: "Find Trials", link: "/#find_trial" },
  {
    title: "Search Results",
    link: `/results?q=NCT03043313&in=UNITED%20STATES`,
  },
  {
    title: "Trial Details",
    link: `/study/NCT03043313`,
  },
];

class NCT03043313 extends React.Component {
  
  render() {
    return (
      <div>
        {this.props.location &&
        this.props.location.search &&
        this.props.location.search.indexOf("embed=true") !== -1 ? null : (
          <>
            <RecruitmentSteps step={"Review Trials"} />
            <div className="container d-flex align-items-center justify-content-start">
              <ScreenFlow flow={flowarray} />
            </div>
          </>
        )}
        <div className="container">
          <iframe style={{height:3000,width:'100%',border:'none'}} title="NCT03043313" src="https://connect.trialscope.com/studies/37b3aebe-06c6-46c9-a150-95d7ecfb4cb0?embed=1"></iframe>
        </div>
      </div>
    );
  }
}

export default NCT03043313;
